/* eslint-disable no-unused-vars */
import { X } from 'lucide-react';
import React from 'react';
import { CopyButton } from '../CopyButton';
import type { UseActionDialogReturn } from '../../hooks/useActionDialog';

type ApiKeyRevealDialogProps = {
  actionDialogReturn: UseActionDialogReturn;
  onNavigate: (path: string, opts?: { replace?: boolean }) => void;
};

function ApiKeyRevealDialog({ actionDialogReturn, onNavigate: _onNavigate }: ApiKeyRevealDialogProps) {
  const {
    actionDialog,
    dialogBusy,
    setActionDialog,
  } = actionDialogReturn;

  if (!actionDialog || actionDialog.kind !== 'api-key-reveal') return null;

  const close = () => { if (!dialogBusy) setActionDialog(null); };

  return (
    <div className="dialogOverlay" role="presentation" onClick={close}>
      <div className="dialogPanel" onClick={(e) => e.stopPropagation()}>
        <div className="dialogHeader">
          <div>
            <div className="panelKicker">Cindro API keys</div>
            <h3>Key created — copy it now</h3>
            <p>This is the only time this key will be shown. Store it somewhere safe.</p>
          </div>
          <button type="button" className="iconButton" onClick={close} aria-label="Close dialog">
            <X size={16} />
          </button>
        </div>
        <div className="settingsForm">
          <label className="settingsField">
            <span>{actionDialog.name}</span>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                readOnly
                value={actionDialog.rawKey}
                style={{ fontFamily: 'monospace', fontSize: 12 }}
                onFocus={(e) => e.target.select()}
              />
              <button
                type="button"
                className="secondaryButton"
                style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                onClick={() => navigator.clipboard.writeText(actionDialog.rawKey)}
              >
                Copy
              </button>
            </div>
            <p className="fieldHint" style={{ color: 'var(--amber)' }}>
              This key will not be shown again after closing this dialog.
            </p>
          </label>
          <div className="keyRevealEnvHint">
            <span className="keyRevealEnvHintLabel">Set as environment variable</span>
            <div className="keyRevealEnvRow">
              <code className="keyRevealEnvCode">CINDRO_API_KEY={actionDialog.rawKey}</code>
              <CopyButton value={`CINDRO_API_KEY=${actionDialog.rawKey}`} label="Copy env var" />
            </div>
            <div className="keyRevealEnvRow">
              <code className="keyRevealEnvCode">npm install @cindro/sdk</code>
              <CopyButton value="npm install @cindro/sdk" label="Copy install command" />
            </div>
          </div>
        </div>
        <div className="dialogActions">
          <button type="button" className="primaryButton" onClick={close}>Done</button>
        </div>
      </div>
    </div>
  );
}

export { ApiKeyRevealDialog };
